import { TextField } from "@mui/material";
import { Box } from "@mui/system";
import { IFilter, initFilterData } from "./index";
import TableFilterAcionts from "../TableFilterAcionts";

interface IProps {
  filter: IFilter;
  setFilter: (filter: IFilter) => void;
  handleSearch: (data?: IFilter) => void;
}

export default function FilterForm({
  filter,
  setFilter,
  handleSearch,
}: IProps) {
  const handleChanges = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter({
      ...filter,
      data: {
        ...filter.data,
        [event.target.name]: event.target.value,
      },
    });
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
        <TextField
          label="Categories Name"
          variant="standard"
          value={filter.data.name}
          name="name"
          onChange={handleChanges}
          sx={{ flex: "1 1 40%" }}
        />
        <TextField
          label="Note"
          variant="standard"
          value={filter.data.notes}
          name="notes"
          onChange={handleChanges}
          sx={{ flex: "1 1 40%" }}
        />
      </Box>
      <TableFilterAcionts
        handleClearSearch={() => {
          setFilter(initFilterData);

          handleSearch(initFilterData)
        }}
        handleSearch={handleSearch}
      />
    </Box>
  );
}
